import { useMutation, useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import type { ApiError } from "@circle-react/config/CustomErrors";
import {
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";

export const useNotificationPreferences = () => {
  const toast = useToast();

  const getOptions = useQuery(
    ["notification-preference"],
    () => reactQueryGet(internalApi.notificationPreferences.index()),
    {
      notifyOnChangeProps: [
        "data",
        "error",
        "isLoading",
        "refetch",
        "isFetching",
      ],
    },
  );

  const { mutateAsync: updatePreferences } = useMutation<
    unknown,
    ApiError,
    any
  >(
    updatedPreferences =>
      reactQueryPatch(
        internalApi.notificationPreferences.update(),
        updatedPreferences,
      ),
    {
      onSuccess: () => {
        toast.success(t("changes_saved"));
      },
      onError: () => {
        toast.error(t("request_failure_message"));
      },
    },
  );

  const unsubscribeAllOptions = useMutation<unknown, ApiError, void>(
    () => reactQueryPost(internalApi.notificationPreferences.unsubscribeAll()),
    {
      onSuccess: () => {
        toast.success(t("changes_saved"));
        void getOptions.refetch();
      },
      onError: () => {
        toast.error(t("request_failure_message"));
      },
    },
  );

  return {
    get: getOptions,
    update: { updatePreferences },
    unsubscribeAll: {
      unsubscribeAll: unsubscribeAllOptions.mutateAsync,
      ...unsubscribeAllOptions,
    },
  };
};
